module.exports = __webpack_public_path__ + "img/jxk_cqdz.c7c7bff0.svg";